export enum AsyncJobProcessTypeEnum {
	EXPORT_RESTRICTED_PLAN = 'EXPORT_RESTRICTED_PLAN',
	EXPORT_CONSENSUS = 'EXPORT_CONSENSUS',
	EXPORT_PLANNING_COLLAB = 'EXPORT_PLANNING_COLLAB',
	EXPORT_MARKETING_COLLAB = 'EXPORT_MARKETING_COLLAB',
	EXPORT_COMMERCIAL_COLLAB = 'EXPORT_COMMERCIAL_COLLAB',
	GENERATE_RESTRICTED_PLAN = 'GENERATE_RESTRICTED_PLAN',
}

export enum AsyncJobStatusEnum {
	PENDING = 'pending',
	RUNNING = 'running',
	COMPLETED = 'completed',
	FAILED = 'failed',
	EXPIRED = 'expired',
}

export interface AsyncJob {
	id: number;
	user_id: number;
	log_id: number;
	process_type: AsyncJobProcessTypeEnum;
	status: AsyncJobStatusEnum;
	progress: number;
	start_date: string | null;
	finish_date: string | null;
	result_description: string | null;
	s3_path: string | null;
	local_path: string | null;
	file_size: number | null;
	combinations_size: number | null;
	createdAt: string;
	updatedAt: string;
}

export interface AsyncJobInfo {
	id: number;
	status: AsyncJobStatusEnum;
	progress: number;
	status_label: string;
	process_type_label: string;
	download_url: string | null;
	result_description: string | null;
	start_date: string | null;
	finish_date: string | null;
}

export interface CheckOngoingExportRequest {
	process_type: AsyncJobProcessTypeEnum;
	cycle_id?: number;
}

export interface CheckOngoingExportResponse {
	has_ongoing: boolean;
	job: AsyncJob | null;
}

export interface RequestExportResponse {
	job: AsyncJob;
	message: string;
}

export interface LogActivityItem {
	id: number;
	data_hora: string;
	endpoint: string;
	metodo: string;
	modelo: string;
	acao: string;
	descricao_acao: string;
	usuario_id: number;
	nome_usuario: string;
	usuario_email: string;
	async_job?: AsyncJobInfo;
}

export interface LogViewResponse {
	data: LogActivityItem[];
	count: number;
	page: number;
	size: number;
	totalPages: number;
}

export const STATUS_LABELS: Record<AsyncJobStatusEnum, string> = {
	[AsyncJobStatusEnum.PENDING]: 'Não iniciado',
	[AsyncJobStatusEnum.RUNNING]: 'Em andamento',
	[AsyncJobStatusEnum.COMPLETED]: 'Finalizado',
	[AsyncJobStatusEnum.FAILED]: 'Falha',
	[AsyncJobStatusEnum.EXPIRED]: 'Expirado',
};

export const PROCESS_TYPE_LABELS: Record<AsyncJobProcessTypeEnum, string> = {
	[AsyncJobProcessTypeEnum.EXPORT_RESTRICTED_PLAN]: 'Exportar Plano Restrito',
	[AsyncJobProcessTypeEnum.EXPORT_CONSENSUS]: 'Exportar Consenso',
	[AsyncJobProcessTypeEnum.EXPORT_PLANNING_COLLAB]:
		'Exportar Colaboração de Planejamento',
	[AsyncJobProcessTypeEnum.EXPORT_MARKETING_COLLAB]:
		'Exportar Colaboração de Marketing',
	[AsyncJobProcessTypeEnum.EXPORT_COMMERCIAL_COLLAB]:
		'Exportar Colaboração Comercial',
	[AsyncJobProcessTypeEnum.GENERATE_RESTRICTED_PLAN]: 'Gerar Plano Restrito',
};

export const STATUS_COLOR_SCHEMES: Record<AsyncJobStatusEnum, string> = {
	[AsyncJobStatusEnum.PENDING]: 'gray',
	[AsyncJobStatusEnum.RUNNING]: 'blue',
	[AsyncJobStatusEnum.COMPLETED]: 'green',
	[AsyncJobStatusEnum.FAILED]: 'red',
	[AsyncJobStatusEnum.EXPIRED]: 'gray',
};

export const STATUS_TEXT_COLORS: Record<AsyncJobStatusEnum, string> = {
	[AsyncJobStatusEnum.PENDING]: 'gray.500',
	[AsyncJobStatusEnum.RUNNING]: 'blue.500',
	[AsyncJobStatusEnum.COMPLETED]: 'green.500',
	[AsyncJobStatusEnum.FAILED]: 'red.500',
	[AsyncJobStatusEnum.EXPIRED]: 'gray.500',
};
